<template>
    <div class="inline">
        <el-form-item :label="comObj[0].label">
            <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="-"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="selDateRange">
            </el-date-picker>
        </el-form-item>
    </div>
</template>

<script>
export default {
    name: 'app',
    watch: {
        modelData: function (val, oldVal) {
            if (val =='' ) {
                this.date=[];
            }
        },
        date(val){
            this.$emit('update:value', val)
        }
    },
    data() {
        var year = new Date().getFullYear();
        var that = this;
        return {
        };
    },
    props: {
        comObj: {
            type: Array,
            default: () => []
        },
    },
    computed: {
        dateRange: {
            get() {
                if(this.comObj.length === 2) {
                    if(this.comObj[0].value == '' && this.comObj[1].value == '') {
                        return []
                    } else {
                        return [this.comObj[0].value, this.comObj[1].value]
                    }

                }
            },
            set(val) {
                this.comObj[0].value = val[0]
                this.comObj[1].value = val[1]
            }
        }
    },
    methods: {
        selDateRange(val) {
            // this.comObj[0].value = val[0]
            // this.comObj[1].value = val[1]
        },
    },
    watch: {
        comObj: {
            handler(val) {
                // console.log(typeof(val))
                this.$emit('update:comObj', val)
            },
            deep: true
        }
    },
    created() {

    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/reports/codeCom/dateRange.vue?72de28bb